import {COLOR_BLACK} from "@/themes/colors.jsx";

const MuiSelectThemeComponents = {
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    paddingLeft: 16,
                    fontSize: 16,
                    color: COLOR_BLACK,
                },
            },
        },
    },
};

export default MuiSelectThemeComponents;
